import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex mb-3 item-hover",
  style: {"padding":"5px 2px !important"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-37px me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "symbol-label symbol-item" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa-sharp fa-solid fa-file-pdf fs-1 text-success" })
  ])
], -1)
const _hoisted_3 = { class: "d-flex flex-column text-hover-primary" }
const _hoisted_4 = { class: "text-dark fs-6 fw-bold f-13" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  class: "d-flex mb-3 item-hover",
  style: {"padding":"5px 2px !important"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-37px me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "symbol-label symbol-item" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa-sharp fa-solid fa-file-pdf fs-1 text-success" })
  ])
], -1)
const _hoisted_8 = { class: "d-flex flex-column text-hover-primary" }
const _hoisted_9 = { class: "text-dark fs-6 fw-bold f-13" }
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return ($props.to)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: $props.to
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString($props.title), 1),
              _createElementVNode("span", {
                class: "text-muted fw-bold f-10",
                innerHTML: $props.info
              }, null, 8, _hoisted_5)
            ])
          ])
        ]),
        _: 1
      }, 8, ["to"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString($props.title), 1),
          _createElementVNode("span", {
            class: "text-muted fw-bold f-10",
            innerHTML: $props.info
          }, null, 8, _hoisted_10)
        ])
      ]))
}